module.exports = __webpack_public_path__ + "static/media/ic-replay.6e738083.svg";